export enum CATALOGUE_IDS {
  BANESCO_PRODUCTS = '28',
  ID_TYPES = '6',
  BANESCO_CURRENCY = '7',
  BENEFICIARY_PRODUCT_TYPES = '10',
  BENEFICIARY_TYPES = 'TBBUSIN',
  BANKS = 'BankBL',
  LOCAL_SENDING_CHANNEL = 'TRFLOC',
  REGIONAL_SENDING_CHANNEL = 'TRFRGN',
  INTERNATIONAL_SENDING_CHANNEL = 'TRFINT',
  LOCAL_TRANSFER_CURRENCIES = 'TRASFCRY',
  INTERNATIONAL_TRANSFER_CURRENCIES = 'TRINTCRY',
  SERVICE_CATEGORIES = 'PGFI',
  INTERNATIONAL_REASONS = 'TRNRAZFCT',
  TAX_COLLECTORS = 'IMP',
  STOCK_EXCHANGE = 'BankPV',
  REGIONAL_BANKS = 'BankRI',
}
